import { ANALYTICS_CONFIG } from '../config/analytics-config.js';
import { getIdToken } from './firebase-auth.js';

const BASE_PATH = '/api/v2/meta/ana';

async function anaRequest(path = '', options = {}, retryAuth = false) {
  const token = await getIdToken(!!retryAuth);
  const url = ANALYTICS_CONFIG.apiBase.replace(/\/$/, '') + BASE_PATH + path;
  const method = options.method || 'GET';
  const response = await fetch(url, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    },
    body: method === 'GET' ? undefined : JSON.stringify(options.body || {})
  });

  if (response.status === 401 && !retryAuth) return anaRequest(path, options, true);
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const message =
      (payload && (payload.message || (payload.error && payload.error.message) || payload.error)) ||
      'No se pudo actualizar la configuración de Ana.';
    const error = new Error(String(message));
    error.status = response.status;
    error.payload = payload;
    throw error;
  }
  return payload || {};
}

export async function fetchAnaOverview() {
  return anaRequest('/overview');
}

export async function fetchAnaActivity({ channel = '', direction = '', query = '', limit = 300 } = {}) {
  const params = new URLSearchParams();
  if (channel) params.set('channel', channel);
  if (direction) params.set('direction', direction);
  if (query) params.set('q', query);
  params.set('limit', String(limit));
  return anaRequest('/activity?' + params.toString());
}

export async function setAnaChannelMode(channel, mode) {
  const payload = await anaRequest('/channels/' + encodeURIComponent(channel), {
    method: 'PATCH',
    body: { mode }
  });
  return payload.channel;
}

export async function fetchInstagramPolicies() {
  const payload = await anaRequest('/instagram/policies');
  return Array.isArray(payload.policies) ? payload.policies : [];
}

export async function saveInstagramPolicy(userId, policy) {
  const payload = await anaRequest('/instagram/policies/' + encodeURIComponent(userId), {
    method: 'PUT',
    body: policy || {}
  });
  return payload.policy;
}
